export class UserTokenModel {
    id: string = "";
    userName: string = "";
    userNameSlug: string = "";
    email: string = "";
    phone: string = "";
    mfa: boolean = false;
    token: string = "";
    refreshToken: string = "";
}
